import { render, staticRenderFns } from "./Prioridades.vue?vue&type=template&id=04e8e4f6&scoped=true"
import script from "./Prioridades.vue?vue&type=script&lang=js"
export * from "./Prioridades.vue?vue&type=script&lang=js"
import style0 from "./Prioridades.vue?vue&type=style&index=0&id=04e8e4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8e4f6",
  null
  
)

export default component.exports